const BookingType = {
  LubeservOnWheels: "lubeserv-on-wheels",
  LubeservOnSite: "lubeserv-on-site",
};

export default BookingType;
